function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var NFTAtomizeTemplate = require('./nft-atomize.template');
var SaitoNFT = require('./../saito-nft');
var NFTAtomize = /*#__PURE__*/function () {
  function NFTAtomize(app, mod, container, nft, utxoIdx) {
    var _nft$slip1$amount, _nft$slip;
    _classCallCheck(this, NFTAtomize);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.nft = nft;
    this.utxoIdx = utxoIdx;

    //
    // Limits (should be injected from parent if needed)
    //
    this.MAX_NFT_ATOMIZE_PER_TX = 20;
    this.MAX_NFT_ATOMIZE_TOTAL = 100;
    this.MAX_NFT_ATOMIZE_TX_PER_BLOCK = 5;

    //
    // State
    //
    this.active = false;
    this.state = {
      nft_id: nft.id,
      initial_amount: Number((_nft$slip1$amount = (_nft$slip = nft.slip1) === null || _nft$slip === void 0 ? void 0 : _nft$slip.amount) !== null && _nft$slip1$amount !== void 0 ? _nft$slip1$amount : nft.amount) || 0,
      pending: new Map(),
      inflight: new Set(),
      done: new Set(),
      tx_sent_this_cycle: 0
    };
    this.walletListener = this.onWalletUpdate.bind(this);
    this.reassuranceInterval = null;
  }
  return _createClass(NFTAtomize, [{
    key: "render",
    value: function render() {
      var _this = this;
      if (!this.state.initial_amount || this.state.initial_amount < 1) {
        console.error('NFTAtomize: invalid initial_amount', this.state.initial_amount);
        return;
      }
      if (this.state.initial_amount > this.MAX_NFT_ATOMIZE_TOTAL) {
        salert("Atomization limit exceeded. Maximum allowed is ".concat(this.MAX_NFT_ATOMIZE_TOTAL, "."));
        return;
      }

      //
      // Initialize pending and done from current wallet (read-only)
      //
      var nft_list = this.app.options.wallet.nfts || [];
      this.state.pending.clear();
      this.state.done.clear();
      this.state.inflight.clear();
      var _iterator = _createForOfIteratorHelper(nft_list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _slip$slip, _slip$slip2;
          var slip = _step.value;
          if (String(slip.id) !== String(this.state.nft_id)) continue;
          var key = (_slip$slip = slip.slip1) === null || _slip$slip === void 0 ? void 0 : _slip$slip.utxo_key;
          if (!key) continue;
          var amt = Number((_slip$slip2 = slip.slip1) === null || _slip$slip2 === void 0 ? void 0 : _slip$slip2.amount);
          if (amt > 1) this.state.pending.set(key, amt);else if (amt === 1) this.state.done.add(key);
        }

        //
        // Replace parent container content
        //
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.app.browser.replaceElementBySelector(NFTAtomizeTemplate(this.utxoIdx, this.state.initial_amount), this.container);
      this.active = true;

      //
      // Reassurance text rotation
      //
      this.reassuranceInterval = setInterval(function () {
        _this.rotateStatusMessage();
      }, 8000);

      //
      // Close button just stops engine
      //
      var closeBtn = document.querySelector('.nft-atomize-stop');
      if (closeBtn) {
        closeBtn.onclick = function () {
          _this.shutdown();
        };
      }

      //
      // Kick off first cycle
      //
      this.processStep();
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      if (!this.active) return;
      this.active = false;
      if (this.reassuranceInterval) {
        clearInterval(this.reassuranceInterval);
      }
    }
  }, {
    key: "onWalletUpdate",
    value: function onWalletUpdate() {
      console.log('into onWallet Update: ' + this.active);
      if (!this.active) {
        return;
      }
      var nft_list = this.app.options.wallet.nfts || [];
      var walletKeys = new Set();
      var _iterator2 = _createForOfIteratorHelper(nft_list),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _slip$slip3;
          var slip = _step2.value;
          if (String(slip.id) !== String(this.state.nft_id)) continue;
          var _key = (_slip$slip3 = slip.slip1) === null || _slip$slip3 === void 0 ? void 0 : _slip$slip3.utxo_key;
          if (_key) walletKeys.add(_key);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      for (var _i = 0, _Array$from = Array.from(this.state.inflight); _i < _Array$from.length; _i++) {
        var key = _Array$from[_i];
        if (!walletKeys.has(key)) this.state.inflight["delete"](key);
      }
      var _iterator3 = _createForOfIteratorHelper(nft_list),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _slip$slip4, _slip$slip5;
          var _slip = _step3.value;
          if (String(_slip.id) !== String(this.state.nft_id)) continue;
          var _key2 = (_slip$slip4 = _slip.slip1) === null || _slip$slip4 === void 0 ? void 0 : _slip$slip4.utxo_key;
          if (!_key2) continue;
          var amt = Number((_slip$slip5 = _slip.slip1) === null || _slip$slip5 === void 0 ? void 0 : _slip$slip5.amount);
          if (amt === 1) this.state.done.add(_key2);else if (amt > 1 && !this.state.inflight.has(_key2)) this.state.pending.set(_key2, amt);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      this.state.tx_sent_this_cycle = 0;
      this.processStep();
    }
  }, {
    key: "processStep",
    value: function processStep() {
      if (!this.active) return;
      this.updateProgressUI();
      console.log(this.state);
      if (this.state.pending.size === 0 && this.state.inflight.size === 0) {
        this.finish();
        return;
      }
      if (this.state.tx_sent_this_cycle >= this.MAX_NFT_ATOMIZE_TX_PER_BLOCK) {
        return;
      }
      if (this.state.pending.size === 0) return;
      var pendingEntries = Array.from(this.state.pending.entries());
      pendingEntries.sort(function (a, b) {
        return b[1] - a[1];
      });
      var _pendingEntries$ = _slicedToArray(pendingEntries[0], 2),
        utxoKey = _pendingEntries$[0],
        amount = _pendingEntries$[1];
      this.splitSlip(utxoKey, amount);
    }
  }, {
    key: "splitSlip",
    value: function () {
      var _splitSlip = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(utxoKey, amount) {
        var nft_list, slip, slipNFT, _this$nft, tx, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              this.state.pending["delete"](utxoKey);
              this.state.inflight.add(utxoKey);
              nft_list = this.app.options.wallet.nfts || [];
              slip = nft_list.find(function (n) {
                var _n$slip;
                return ((_n$slip = n.slip1) === null || _n$slip === void 0 ? void 0 : _n$slip.utxo_key) === utxoKey;
              });
              if (slip) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              slipNFT = slip;
              if (typeof slipNFT.fetchTransaction !== 'function') {
                slipNFT = new SaitoNFT(this.app, this.mod, (_this$nft = this.nft) === null || _this$nft === void 0 ? void 0 : _this$nft.tx, slip);
              }
              _context.n = 2;
              return slipNFT.fetchTransaction();
            case 2:
              this.app.browser.safeConsole('slipNFT: ', slipNFT, 'debug');
              if (!(amount > this.MAX_NFT_ATOMIZE_PER_TX)) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return this.app.wallet.createSplitNFTTransaction(slipNFT, this.MAX_NFT_ATOMIZE_PER_TX, amount - this.MAX_NFT_ATOMIZE_PER_TX);
            case 3:
              tx = _context.v;
              _context.n = 6;
              break;
            case 4:
              _context.n = 5;
              return this.app.wallet.createSplitNFTTransaction(slipNFT, 1, amount - 1);
            case 5:
              tx = _context.v;
            case 6:
              _context.n = 7;
              return tx.sign();
            case 7:
              _context.n = 8;
              return this.app.network.propagateTransaction(tx);
            case 8:
              this.state.tx_sent_this_cycle++;
              _context.n = 10;
              break;
            case 9:
              _context.p = 9;
              _t = _context.v;
              console.error('Atomize split failed:', _t);
              this.state.inflight["delete"](utxoKey);
              this.state.pending.set(utxoKey, amount);
            case 10:
              return _context.a(2);
          }
        }, _callee, this, [[0, 9]]);
      }));
      function splitSlip(_x, _x2) {
        return _splitSlip.apply(this, arguments);
      }
      return splitSlip;
    }()
  }, {
    key: "updateProgressUI",
    value: function updateProgressUI() {
      var el = document.querySelector('.nft-atomize-progress');
      if (!el) return;
      el.innerText = "".concat(this.state.done.size, " / ").concat(this.state.initial_amount);
    }
  }, {
    key: "rotateStatusMessage",
    value: function rotateStatusMessage() {
      if (!this.active) return;
      var el = document.querySelector('.nft-atomize-status');
      if (!el) return;
      var messages = ['Waiting for network confirmation...', 'Submitting split transactions...', 'Processing NFT shards...', 'Updating wallet state...'];
      el.innerText = messages[Math.floor(Math.random() * messages.length)];
    }
  }, {
    key: "finish",
    value: function finish() {
      this.active = false;
      var statusEl = document.querySelector('.nft-atomize-status');
      if (statusEl) {
        statusEl.innerText = 'Atomization complete.';
      }
      if (this.reassuranceInterval) {
        clearInterval(this.reassuranceInterval);
      }
      document.querySelector('.split-number-box i').remove();
    }
  }]);
}();
module.exports = NFTAtomize;